import React from "react";
import { whatsappLink } from "@/lib/api";
import { MessageCircle } from "lucide-react";

export const WhatsAppButton = ({ message = "Bonjour IMmOMAXE, je souhaite être accompagné(e).", label, className = "", variant = "solid", testid = "whatsapp-btn" }) => {
  const base = "inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-all duration-300";
  const styles =
    variant === "solid"
      ? "bg-[#25D366] text-white hover:bg-[#1eb457] px-5 py-2.5 shadow-sm hover:shadow-md"
      : "border border-[#25D366] text-[#128C4B] hover:bg-[#25D366]/10 px-5 py-2.5";
  return (
    <a href={whatsappLink(message)} target="_blank" rel="noopener noreferrer" className={`${base} ${styles} ${className}`} data-testid={testid}>
      <MessageCircle className="h-4 w-4" />
      {label || "WhatsApp"}
    </a>
  );
};

export const FloatingWhatsApp = () => (
  <a
    href={whatsappLink("Bonjour IMmOMAXE, je souhaite parler à un conseiller.")}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp"
    className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl transition-transform duration-300 hover:scale-110"
    aria-label="WhatsApp"
  >
    <MessageCircle className="h-7 w-7" />
  </a>
);
